<template>
  <div v-if="chatContact != null" class="chat__header chat-navbar-component">
    <vs-navbar class="p-4 flex navbar-custom" color="white" type="flat">
      <div class="relative flex mr-2">
        <feather-icon
          icon="MenuIcon"
          class="mr-4 cursor-pointer"
          v-if="isSidebarCollapsed && !isSmallScreen"
          @click.stop="$emit('openContactsSidebar')"
        />
        <vs-avatar
        class="m-0 border-2 border-solid border-white"
        size="40px"
        :src="chatContact.customer.image"
        @click.stop="$emit('showProfileSidebar', chatContact)"
        />
      </div>
      <div
        class="w-full flex"
        :class="{
          'justify-center items-center': chatContact.finished_at === null
        }"
      >
        <div
          :class="{
            'w-6/12': customerLastChat && chatContact.finished_at === null
          }"
        >
          <h6>{{ chatContact.customer.name }}</h6>
          <vs-td>
              <p class="product-phone-number font-medium truncate">{{ maskedPhone }}</p>
          </vs-td>
        </div>
        <div
          class="w-6/12 flex justify-end"
          v-if="customerLastChat && chatContact.finished_at === null && chatContact.is_finishing === false && finishedTickets === false"
        >
          <div class="flex mt-1 ml-8">
            <div v-if="openSearch" class="flex" id="search-input-navbar">
              <vs-input-number
                  min="0"
                  :max="maxValues"
                  v-model="indexSearch"
                  class="w-3 h-8"
                  icon-inc="expand_less"
                  icon-dec="expand_more"
              />

              <vs-input
                  icon-no-border
                  icon="icon-search"
                  icon-pack="feather"
                  v-model="searchQuery"
                  @focusout.prevent="searchMessages"
                  class="input-rounded-full"
                  :class="{ 'input-search-ios': isIos, 'input-search-msg-android': isAndroid }"
                  :placeholder="(isIos || isAndroid) ? 'Busque' : 'Busque pela mensagem'"
              />
            </div>
            <div v-if="!isSmallScreen" class="flex align-items-center select-none">
              <div v-if="instanceColor">
                <vs-chip :title="instanceColor.name" :color="instanceColor.color">
                  {{ instanceColor.name | truncate(20, true)}}
                </vs-chip>
              </div>
              <VsDropdown>
                <vs-button radius color="primary" type="flat" icon="filter_list"></vs-button>

                <VsDropdownMenu>
                  <VsDropdownItem @touchstart.prevent="popupDateFilter=true" @click="popupDateFilter=true">
                    <vs-icon class="mr-2" icon="event" style="-webkit-transform: scaleX(-1); transform: scaleX(-1);"/>
                    Filtrar por data
                  </VsDropdownItem>
                  <VsDropdownItem @touchstart.prevent="openSearch = !openSearch" @click="openSearch = !openSearch">
                    <vs-icon class="mr-2" icon="search" style="-webkit-transform: scaleX(-1); transform: scaleX(-1);"/>
                    Pesquisar mensagem
                  </VsDropdownItem>
                </VsDropdownMenu>
              </VsDropdown>
            </div>
          </div>
          <div v-if="hasOrderFeature">
            
            <div v-if="!isSmallScreen">
              <VsDropdown v-if="canSee('orders') || canSee('pre-orders') || canSee('products') || canSee('services')">
                <vs-button class="btn-drop px-3 mr-2" type="filled" icon="expand_more" icon-after>
                  Pedidos
                </vs-button>
    
                <VsDropdownMenu>

                  <VsDropdownItem v-if="canSee('pre-orders')" @touchstart.prevent="openPreOrdersModal=true" @click.prevent="openPreOrdersModal=true">
                    <vs-icon class="mr-2" icon="search" style="-webkit-transform: scaleX(-1); transform: scaleX(-1);">
    
                    </vs-icon>
                    <span>Orçamento</span>
                  </VsDropdownItem>
                  
                  <VsDropdownItem v-if="canSee('products') || canSee('services')" @click.prevent="openProductsModal=true" @touchstart.prevent="openProductsModal=true">
                    <vs-icon class="mr-2" icon="shopping_basket" style="-webkit-transform: scaleX(-1); transform: scaleX(-1);">
    
                    </vs-icon>
                    <span>Produtos</span> <span v-if="canSee('services') && hasServicesFeature">/ Serviços</span>
                  </VsDropdownItem>

                  <VsDropdownItem v-if="canSee('orders')" @touchstart.prevent="openOrdersModal=true" @click.prevent="openOrdersModal=true">
                    <vs-icon class="mr-2" icon="format_list_bulleted" style="-webkit-transform: scaleX(-1); transform: scaleX(-1);">
    
                    </vs-icon>
                    <span>Pedidos</span>
                  </VsDropdownItem>
                  
                </VsDropdownMenu>
              </VsDropdown>
            </div>
            
            <PreOrdersPopUp 
              :isActive="openPreOrdersModal" 
              @isActiveFalse="openPreOrdersModal=false" 
              @turnIntoOrder="turnIntoOrder"
              @createPreOrder="createPreOrder"
              :customerId="chatContact.customer.id"
            />
            <OrderSummaryPopUp 
              :isActive="openOrderSummaryModal" 
              :dataOfTurnIntoOrder="dataOfTurnIntoOrder" 
              @isActiveFalse="openOrderSummaryModal=false"
              @backToPreOrder="backToPreOrder"
              @editDeliveryOptions="editDeliveryOptions"
              @editPaymentOptions="editPaymentOptions"
              @editProductOptions="editProductOptions"
              :modalToTransformIsActive="modalToTransformIsActive"
              @linkUser="linkUser"
              :currentUser="currentUser"
              :selectedUser="selectedUser"
              @removeSelectedUser="selectedUser = null"
              @editNotesAndFiles="editNotesAndFiles"
              @editCustomerKnow="editCustomerKnow"
              :currentKnow="currentKnow"
              :customer="chatContact.customer"
              @addCustomerDocument="addCustomerDocument"
            />
            <customerKnowledgePopup
                :in-flow="true"
                :is-active="openCustomerKnowledgeModal"
                :customer-id="chatContact.customer.id"
                :currentKnow="customerKnowledge"
                @backPage="popupKnowledge"
                @knowledgeClose="popupKnowledge"
                @closeModalCustomerKnow="openCustomerKnowledgeModal = false"
                @setCurrentKnow="setCurrentKnowledge"
                :isUpdate="isUpdate"
                @backUpdateKnow="backUpdateKnow"
                :dataOfTurnIntoOrder="this.dataOfTurnIntoOrder"
            />
            <LinkUserPopUp
              :isActive="openLinkUserPopUp"
              @isActiveFalse="openLinkUserPopUp=false"
              @backToOrerSummarry="backToOrerSummarry"
              @changeUser="changeUser"
            />
            <CustomerDocumentPopUp
              :isActive="openCustomerDocumentModal"
              @isActiveFalse="closeModalCustomerDocument"
              :backIsVisible="backIsVisible"
              @backToPreOrders="backToPreOrders"
              :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
              @sendToProductFlow="sendToProductFlow"
              :dataToUpdate="dataToUpdate"
              :isCreateContext="isCreateContext"
              :chatTicket="chatTicket"
              @backToOrderSummary="backToOrderSummary"
              :customer="chatContact.customer"
              :context="orderContext"
              @backToFinishOrder="backToFinishOrder"
            />
            <ProductsPopUp
              :isActive="openProductsModal"
              @isActiveFalse="closeProduct" 
              :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
              :backIsVisible="backIsVisible"
              @backToCustomerDocument="backToCustomerDocument"
              @addQuantity="addQuantity"
              @backToOrderSummary="backToOrderSummary"
              :dataToUpdate="dataToUpdate"
              :isCreateContext="isCreateContext"
              :updatePreOrder="updatePreOrder"
              />
            <OrdersPopUp 
              :isActive="openOrdersModal" 
              @isActiveFalse="openOrdersModal=false"
              />
            <QuantitypopUp
              :isActive="openQuantityModal" 
              @isActiveFalse="closeQuantity"
              :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
              @backToProducts="backToProducts"
              :quantityList="quantityList"
              @sendDeliveryFlow="sendDeliveryFlow"
              :isCreateContext="isCreateContext"
              :dataToUpdate="dataToUpdate"
              @updateProducts="backToOrderSummary"
              @setDiscountPrice="setDiscountPrice"
              @updatePreOrderProducts="updatePreOrderProducts"
              :updatePreOrder="updatePreOrder"
              />
            <DiscountPopUp
              :isActive="openDiscountModal" 
              @backToQuantity="backToQuantity"
              :dataToSetDiscount="dataToSetDiscount"
              @setNewDiscountPrice="setNewDiscountPrice"
              @setNewDiscountService="setNewDiscountService"
              @backToDiscountModalService="backToDiscountModalService"
              />
            <PaymentPopUp
              :isActive="openPaymentModal"
              @isActiveFalse="closeModalPayment"
              :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
              @sendToNotesAndFiles="sendToNotesAndFiles"
              @backToDelivery="backToDelivery"
              :isCreateContext="isCreateContext"
              @backToOrderSummary="backToOrderSummary"
              :dataToUpdate="dataToUpdate"
              @updateOrderPayment="updateOrderPayment"
              :services="services"
              @backToProducts="backToProducts"/>
            <DeliveryPopUp
              :isActive="openDeliveryModal"
              @isActiveFalse="closeModalDelivery"
              @backToQuantity="backToQuantity"
              :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
              @sendToPayment="sendToPayment"
              :dataToUpdate="dataToUpdate"
              :isCreateContext="isCreateContext"
              :chatContact="chatContact"
              @backToOrderSummary="backToOrderSummary"
              @updateOrderDelivery="updateOrderDelivery"
            />
            <NotesAndFilesPopUp
              :isActive="openNotesAndFilesPopUp"
              @isActiveFalse="openNotesAndFilesPopUp = false"
              @sendToPreOrdersSummary="sendToPreOrdersSummary"
              @backToPayment="backToPayment"
              :isUpdate="isUpdate"
              @backToOrderSummaryFromNotes="backToOrderSummaryFromNotes"
              :orderId="dataOfTurnIntoOrder.id"
            />
            <PreOrderSummaryPopUp
              :isActive="openPreOrderSummaryModal"
              @isActiveFalse="closeModalPreOrders"
              :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
              :chatContact="chatContact"
              @backToNotesAndFiles="backToNotesAndFiles"
              :services="services"
              :chatTicket="this.chatTicket"
              :isActiveSentPreOrderSummary="isActiveSentPreOrderSummary"
              @trueSentPreOrderSummary="isActiveSentPreOrderSummary = true"         
              @falseSentPreOrderSummary="isActiveSentPreOrderSummary = false"
              :currentKnow="currentKnow"
              @openDiscountServiceModal="openDiscountServiceModal"
              @editProductsPreOrder="editProductsPreOrder"
            />
              <div class="select-container flex" v-if="isSmallScreen">
              <VsDropdown vs-trigger-click>
                <vs-button radius color="primary" type="flat" icon="more_vert"></vs-button>

                <VsDropdownMenu>
                  <VsDropdownItem disabled v-if="instanceColor">
                    <p>Conexão: <b :title="instanceColor.name" :style="{ color: instanceColor.color }"> {{ instanceColor.name | truncate(20, true)}} </b></p>
                  </VsDropdownItem>
                  <VsDropdownItem @click="popupDateFilter=true" @touchstart.prevent="popupDateFilter=true">
                    Filtrar por data
                  </VsDropdownItem>
                  <VsDropdownItem @click="openSearch = !openSearch" @touchstart.prevent="openSearch = !openSearch">
                    Pesquisar mensagem
                  </VsDropdownItem>
                    <VsDropdownItem v-if="canSee('pre-orders')" @click.prevent="openPreOrdersModal=true" @touchstart.prevent="openPreOrdersModal=true">
                      Orçamento
                    </VsDropdownItem>
                    <VsDropdownItem v-if="canSee('products') || canSee('services')" @click.prevent="openProductsModal=true" @touchstart.prevent="openProductsModal=true">
                      <span>Produtos</span> <span v-if="canSee('services') && hasServicesFeature">/ Serviços</span>
                    </VsDropdownItem>
                    <VsDropdownItem v-if="canSee('orders')" @click.prevent="openOrdersModal=true" @touchstart.prevent="openOrdersModal=true">
                      Pedidos
                    </VsDropdownItem>
                  <VsDropdownItem v-if="chatTicket && !chatTicket.is_research" @click.prevent="openTransferPopup(chatContact)" @touchstart.prevent="openTransferPopup(chatContact)">
                    Transferir atendimento
                  </VsDropdownItem>
                  <VsDropdownItem @click.prevent="openFinalizePopup(chatContact)" @touchstart.prevent="openFinalizePopup(chatContact)">
                    Encerrar atendimento
                  </VsDropdownItem>
                </VsDropdownMenu>
              </VsDropdown>
              <div v-if="ticketTime && !openSearch && isSmallScreen" class="mr-2">
                  <ticket-timer :datetime="ticketTime"></ticket-timer>
              </div>
            </div>
          </div>
          <div class="select-container flex" v-else>
            <vs-button :class="['btn-drop', 'px-3', {'mr-2': !isSmallScreen}]"  type="filled" :icon="!isSmallScreen ? expand_more: ''" icon-after @click.prevent="openBuyOrderModal()" v-if="!openSearch && (isIos || isAndroid || isSmallScreen)">
              Pedidos
            </vs-button>

            <BuyOrdersPopUp
                :isActive="buyOrderModal"
                @isActiveFalse="buyOrderModal=false"
            ></BuyOrdersPopUp>

            <VsDropdown vs-trigger-click v-if="isSmallScreen">
                <vs-button radius color="primary" type="flat" icon="more_vert"></vs-button>

                <VsDropdownMenu>
                  <VsDropdownItem disabled v-if="instanceColor">
                    <p>Conexão: <b :title="instanceColor.name" :style="{ color: instanceColor.color }"> {{ instanceColor.name | truncate(20, true)}} </b></p>
                  </VsDropdownItem>
                  <VsDropdownItem @click="popupDateFilter=true" @touchstart.prevent="popupDateFilter=true">
                    Filtrar por data
                  </VsDropdownItem>
                  <VsDropdownItem @click="openSearch = !openSearch" @touchstart.prevent="openSearch = !openSearch">
                    Pesquisar mensagem
                  </VsDropdownItem>
                  <VsDropdownItem v-if="chatTicket && !chatTicket.is_research" @touchstart.prevent="openTransferPopup(chatContact)" @click.prevent="openTransferPopup(chatContact)">
                    Transferir atendimento
                  </VsDropdownItem>
                  <VsDropdownItem @touchstart.prevent="openFinalizePopup(chatContact)" @click.prevent="openFinalizePopup(chatContact)">
                    Encerrar atendimento
                  </VsDropdownItem>
                </VsDropdownMenu>
              </VsDropdown>
          </div>
                    
          <div v-if="!isSmallScreen" class="mr-2">
            <VsDropdown>
              <vs-button class="btn-drop px-3" type="filled" icon="expand_more" icon-after>
                Ações
              </vs-button>

              <VsDropdownMenu>
                <VsDropdownItem v-if="chatTicket && !chatTicket.is_research" @touchstart.prevent="openTransferPopup(chatContact)" @click.prevent="openTransferPopup(chatContact)">
                  <vs-icon class="mr-2" icon="reply" style="-webkit-transform: scaleX(-1); transform: scaleX(-1);">

                  </vs-icon>
                  <span>Transferir Atendimento</span>
                </VsDropdownItem>
                <VsDropdownItem @touchstart.prevent="openFinalizePopup(chatContact)" @click.prevent="openFinalizePopup(chatContact)">
                  <vs-icon class="mr-2" icon="highlight_off"></vs-icon>
                  <span>Encerrar Atendimento</span>
                </VsDropdownItem>
              </VsDropdownMenu>
            </VsDropdown>
          </div>

          <div v-if="ticketTime && !openSearch && !isSmallScreen">
              <ticket-timer :datetime="ticketTime"></ticket-timer>
          </div>

        </div>
        <div v-else class="w-11/12 flex justify-end">
          <div class="flex mt-1 mr-2">
            <div v-if="openSearch" class="flex" id="search-input-navbar">
              <vs-input-number
                  min="0"
                  :max="maxValues"
                  v-model="indexSearch"
                  class="w-8 h-8"
                  icon-inc="expand_less"
                  icon-dec="expand_more"
              />

              <vs-input
                  icon-no-border
                  icon="icon-search"
                  icon-pack="feather"
                  v-model="searchQuery"
                  @focusout.prevent="searchMessages"
                  class="input-rounded-full"
                  placeholder="Busque pela mensagem"
              />
            </div>

            <div v-if="!isSmallScreen" class="mr-2 flex align-items-center">
              <div v-if="instanceColor">
                <vs-chip :title="instanceColor.name" :color="instanceColor.color">
                  {{ instanceColor.name | truncate(20, true)}}
                </vs-chip>
              </div>

              <VsDropdown>
                <vs-button radius color="primary" type="flat" icon="filter_list"></vs-button>

                <VsDropdownMenu>
                  <VsDropdownItem @click="popupDateFilter=true" @touchstart.prevent="popupDateFilter=true">
                    <vs-icon class="mr-2" icon="event" style="-webkit-transform: scaleX(-1); transform: scaleX(-1);"></vs-icon>
                    Filtrar por data
                  </VsDropdownItem>
                  <VsDropdownItem @click="openSearch = !openSearch" @touchstart.prevent="openSearch = !openSearch">
                    <vs-icon class="mr-2" icon="search" style="-webkit-transform: scaleX(-1); transform: scaleX(-1);"></vs-icon>
                    Pesquisar mensagem
                  </VsDropdownItem>
                </VsDropdownMenu>
              </VsDropdown>
            </div>
          </div>
        </div>
      </div>
      <vs-spacer></vs-spacer>
      <VsDropdown v-if="isSmallScreen && chatTab === 'inbox'" vs-trigger-click>
        <vs-button radius color="primary" type="flat" icon="more_vert"></vs-button>
        <VsDropdownMenu>
          <VsDropdownItem disabled v-if="instanceColor">
            <p>Conexão: <b :title="instanceColor.name" :style="{ color: instanceColor.color }"> {{ instanceColor.name | truncate(20, true)}} </b></p>
          </VsDropdownItem>
          <VsDropdownItem @click="popupDateFilter=true" @touchstart.prevent="popupDateFilter=true">
            Filtrar por data
          </VsDropdownItem>
          <VsDropdownItem @click="openSearch = !openSearch" @touchstart.prevent="openSearch = !openSearch">
            Pesquisar mensagem
          </VsDropdownItem>
        </VsDropdownMenu>
      </VsDropdown>
      <feather-icon
          icon="MenuIcon"
          class="mr-4 cursor-pointer"
          v-if="isSmallScreen && chatTab !== ''"
          @click.stop="$emit('openContactsSidebar')"
      />
    </vs-navbar>
    <div class="centerx">
    <vs-popup title="Filtro por data" :active.sync="popupDateFilter">
      <div class="inline-flex" :style="{ 'margin-left': (isIos || isAndroid) ? '37%' : '33%' }">
        <flat-pickr
          :config="configDatePicker"
          v-model="selectedDate"
          placeholder="Escolha uma Data"
          v-validate="'required'"
          name="dateSend"
        />
        <vs-button
          icon="cancel"
          color="danger"
          type="flat"
          class="ml-4 mt-2"
          @click="selectedDate=''"
        />
      </div>
      <vs-list>
        <vs-list-header 
          :style="{
            'margin-left': (isIos || isAndroid) ? '10%' : '19%',
            'width': (isIos || isAndroid) ? '20em' : '30em'
          }"
          title="Escolha o dia que você deseja filtrar as mensagens" 
          color="warning">
        </vs-list-header>
        <vs-list-item title="Observação" subtitle="Para auxiliar na sua busca, faremos um filtro diário trazendo apenas as mensagens do dia escolhido.">
          <template slot="avatar">
            <vs-avatar color="warning" icon="info" />
          </template>
        </vs-list-item>
      </vs-list>
      <vs-button v-if="selectedDate === ''" radius color="success" type="gradient" icon="done" style="margin-left: 90%;" disabled></vs-button>
      <vs-button v-else radius color="success" type="gradient" icon="done" style="margin-left: 90%;" @click="filterDate"></vs-button>
    </vs-popup>
  </div>
  </div>
</template>

<script>

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';

import ProductsPopUp from "./products/Products.vue";
import OrdersPopUp from "./orders/Orders.vue";
import PreOrdersPopUp from "./pre-orders/PreOrders.vue";
import OrderSummaryPopUp from "./orders/OrderSummary.vue";

import PaymentPopUp from "./payments/Payment.vue";
import DeliveryPopUp from "./delivery/Delivery.vue";
import CustomerDocumentPopUp from "./customers/CustomerDocument.vue";
import QuantitypopUp from "./products/Quantity.vue";
import DiscountPopUp from "./products/Discount.vue";
import LinkUserPopUp from './users/LinkUser.vue'
import PreOrderSummaryPopUp from "./pre-orders/PreOrderSummary.vue";
import BuyOrdersPopUp from "./orders/BuyOrdersPopUp.vue";
import {maskPhoneNumber, hasPermission, hasFeature, instanceObject} from "@/utils";
import TicketTimer from "@/components/attendance/ticket-timer.vue";
import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";
import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";
import NotesAndFilesPopUp from "../chat-attendance/notes-and-files/NotesAndFiles.vue";
import CustomerKnowledgePopup from "@/views/chat-attendance/services/CustomerKnowledgePopup.vue";

export default {
  components: {
    flatPickr,
    VsDropdown,
    VsDropdownMenu,
    VsDropdownItem,
    TicketTimer,
    ProductsPopUp,
    OrdersPopUp,
    PreOrdersPopUp,
    OrderSummaryPopUp,
    //NewCustomerPopUp,
    PaymentPopUp,
    DeliveryPopUp,
    CustomerDocumentPopUp,
    QuantitypopUp,
    DiscountPopUp,
    NotesAndFilesPopUp,
    PreOrderSummaryPopUp,
    BuyOrdersPopUp,
    LinkUserPopUp,
    CustomerKnowledgePopup
  },
  props: {
    chatContact: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null
    },
    isSidebarCollapsed: {
      type: Boolean,
      required: true
    },
    finishedTickets: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selectedDate: '',
      dateNow: '',
      onlineUsers: [],
      popupDateFilter:false,
      customerServiceClose:false,
      buyOrderModal: false,
      openProductsModal: false,
      openOrdersModal: false,
      openPreOrdersModal: false,
      openOrderSummaryModal: false,
      openCustomerKnowledgeModal: false,
      dataOfTurnIntoOrder: {},
      backIsVisible: false,
      openQuantityModal: false,
      openDiscountModal: false,
      //openNewCustomerModal: false,
      dataOfProductsToPreOrder: {},
      openPaymentModal: false,
      openDeliveryModal: false,
      openCustomerDocumentModal: false,
      quantityList: [],
      openPreOrderSummaryModal: false,
      indexSearch: 0,
      maxValues: 0,
      searchQuery:'',
      openSearch: false,
      transferPopup: false,
      dataToUpdate: {},
      dataToSetDiscount: null,
      isCreateContext: true,
      hasOrderFeature: false,
      hasErpFeature: false,
      hasServicesFeature: false,
      openNotesAndFilesPopUp: false,
      services: [],
      isActiveSentPreOrderSummary: false,
      modalToTransformIsActive: false,
      openLinkUserPopUp: false,
      selectedUser: null,
      customerKnowledge: null,
      currentKnow: null,
      isUpdate: false,
      isSmallScreen: false,
      updatePreOrder: false,
      orderContext: '',
      configDatePicker: {
        enableTime: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: 'd/m/Y',
        maxDate: new Date()
      }
    }
  },
  computed: {
    chatTab() {
      return this.$store.state.chatContact.chatTab;
    },
    customerLastChat() {
      return this.chatContact.customerLastChat ? this.chatContact.customerLastChat : null
    },
    chatTicket() {
      return this.chatContact
    },
    maskedPhone() {
      return maskPhoneNumber(this.chatContact.customer.phone_number);
    },
    searchTrim() {
      const text = this.searchQuery.toLowerCase().trim();
      return text.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚãõÃÕâêîôûÂÊÎÔÛçÇõñÑ\s]/g, '');
    },
    instance(){
      return this.chatContact ? instanceObject(this.chatContact.instance_id) : null
    },
    ticketTime(){
      if (this.instance && this.instance['is_official'] && this.chatTicket && this.chatTicket['last_cost_created_at']){
        return new Date( this.chatTicket['last_cost_created_at'] );
      }
      return null;
    },
    currentUser() {
      return this.$store.state.AppActiveUser;
    },
    instanceColor(){
      if ( this.unifyConnections && this.$store.getters["instance/chosenInstanceIds"].length > 1 && this.instance){
        return {
          name: this.instance.nickname || this.instance.name,
          color: this.instance.color || '#2c2c2c'
        }
      }
      return null;
    },
    unifyConnections() {
      return this.$store.state.settings.settings.unify_connections !== undefined && !!parseInt(this.$store.state.settings.settings.unify_connections);
    },
    isIos() {
      return window.innerWidth <= 430 && window.innerHeight <= 932;
    },
    isAndroid() {
      return window.innerWidth <= 393 && window.innerHeight <= 873;
    },
    isAnyModalOpen() {
      return [
        this.openPreOrdersModal,
        this.openOrderSummaryModal,
        this.openCustomerDocumentModal,
        this.openProductsModal,
        this.openOrdersModal,
        this.openQuantityModal,
        this.openDiscountModal,
        this.openPaymentModal,
        this.openDeliveryModal,
        this.openPreOrderSummaryModal,
        this.isActiveSentPreOrderSummary,
        this.modalToTransformIsActive,
        this.openLinkUserPopUp,
        this.openNotesAndFilesPopUp,
        this.popupDateFilter
      ].some(modal => modal === true);
    }
  },
  watch: {
    transferPopup(val) {
      if (val) {
        this.fetchOnlineUsers();
      }
    },
    chatContact(){
      this.cleanSeach();
    },
    searchQuery() {
      this.activeSearch = true
      this.indexSearch  = 0;
      this.searchMessages();
    },
    openSearch(val) {
      if (!val){
        this.cleanSeach();
      }
    },
    indexSearch() {
      if ( this.searchTrim ){
        this.searchMessages();
      }
    },
  },
  methods: {
    checkScreenWidth() {
      this.isSmallScreen = window.innerWidth <= 768;
    },
    filterDate() {
      if (!this.selectedDate) {
        return this.$vs.notify({
          title:'Você deve selecionar uma data para a filtragem!'
        });
      }

      this.popupDateFilter = false;
      this.$emit('searchDate', this.formatDate(this.selectedDate));
      this.selectedDate = '';
    },
    formatDate(dateString) {
      let [day, month, year] = dateString.split('/');
      return `${year}-${month}-${day}`;
    },
    canSee(action) {
      return hasPermission(`${this.$route.name}-${action}`)
    },
    async openFinalizePopup(contact) {
      this.$store.dispatch('chatContact/setChatFinalizePopup', contact);
      await this.sleep(100);
      this.$store.dispatch('chatContact/changeStatusFinalizePopupActive', true);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async openTransferPopup(contact) {
      this.$store.dispatch('chatContact/setChatTransferPopup', contact);
      await this.sleep(100);
      this.$store.dispatch('chatContact/changeStatusTransferPopupActive', true);
    },
    turnIntoOrder(value) {
      this.openPreOrdersModal = false;
      this.openOrderSummaryModal = true;
      this.dataOfTurnIntoOrder = value;
    },
    backToPreOrder() {
      this.openOrderSummaryModal = false;
      this.openPreOrdersModal = true;
    },
    createPreOrder(value) {
      this.openPreOrdersModal = false;
      this.backIsVisible = value.backIsVisible;

      this.openCustomerDocumentModal = true
      this.cleanEvents();
    },
    backToPreOrders(value) {
      this.openCustomerDocumentModal = false;
      this.openPreOrdersModal = true;
      this.backIsVisible = value.backIsVisible;
    },
    closeProduct() {
      this.openProductsModal = false;
      this.backIsVisible = false;
      this.isCreateContext = true;
      this.cleanEvents();
    },
    popupKnowledge(next = false){
      if ( next === true ) {
        this.openPaymentModal = true;
      } else if (this.dataOfProductsToPreOrder && this.dataOfProductsToPreOrder.delivery) {
        this.openDeliveryModal = true;
      } else if ( this.services && this.services.length > 0 ){
        return this.backToProducts()
      }

      this.customerKnowledge = null;
      this.openCustomerKnowledgeModal = false;
    },
    updateKnowledge(){
      this.openCustomerKnowledgeModal = false;
      this.openOrderSummaryModal      = true
    },
    addQuantity(value, dataToUpdate, services) {
      this.services = services;
      this.openProductsModal = false;

      if (this.isCreateContext && value.length === 0 && services.length !== 0) {
        this.customerKnowledge = null;
        this.dataOfProductsToPreOrder = [];
        this.openCustomerKnowledgeModal = true;
        return;
      }

      this.quantityList = [];
      this.openQuantityModal = true
      this.dataOfProductsToPreOrder.product = value;
      this.dataToUpdate = dataToUpdate;

      let productData = this.dataOfProductsToPreOrder.product === undefined ? this.dataOfProductsToPreOrder : this.dataOfProductsToPreOrder.product;

      for (let index = 0; index <= productData.length; index++) {
        this.quantityList.push(productData[index].quantity || 1);
      }

      this.$vs.loading.close('#app > .con-vs-loading');
    },
    cleanEvents() {
      this.$events.emit('cleanProducts', { 'file': 'Products' })
      this.$events.emit('cleanPayment', { 'file': 'Payment' })
      this.$events.emit('cleanDelivery', { 'file': 'Delivery' })
      this.$events.emit('cleanErp', { 'file': 'Erp' })
    },
    backToProducts(context) {
      if (context === 'serviceContext') {
        this.cleanEvents();
        this.customerKnowledge = null;
        this.openPaymentModal = false;
        this.openProductsModal = false;
        this.openCustomerKnowledgeModal = true
        return;
      }
      this.openCustomerKnowledgeModal = false
      this.openQuantityModal = false;
      this.openProductsModal = true;
      this.customerKnowledge = null;
      this.quantityList = [];
    },
    sendDeliveryFlow(value) {
      this.openQuantityModal = false;
      this.openDeliveryModal = true;
      this.dataOfProductsToPreOrder = value;
    },
    backToQuantity() {
      this.openDeliveryModal = false;
      this.openDiscountModal = false;
      this.openQuantityModal = true;
    },
    backToDiscountModalService(){
      this.openDiscountModal = false;
      this.openPreOrderSummaryModal = true;
    },
    setDiscountPrice(data) {
      data.isService = false;
      this.dataToSetDiscount = data
      this.openDiscountModal = true;
      this.openQuantityModal = false;
    },
    setNewDiscountPrice(value, index) {
      this.openDiscountModal = false;
      this.openQuantityModal = true;
      if (this.dataOfProductsToPreOrder.product === undefined) {
        this.dataOfProductsToPreOrder[index].discount_price = value
      } 
      else {
        this.dataOfProductsToPreOrder.product[index].discount_price = value
      }
    },
    sendToPreOrdersSummary(files, note) {
      for (let index = 0; index < this.services.length; index++) {
        this.services[index].discount_price = this.services[index].price
        this.services[index].percentage_discount = 100;
      }

      this.openNotesAndFilesPopUp = false;
      this.openPreOrderSummaryModal = true;
      this.dataOfProductsToPreOrder.files = files;

      this.dataOfProductsToPreOrder.note = (note && note.trim() !== '') ? note : null;
    },
    openDiscountServiceModal(data) {
      data.isService = true;
      this.dataToSetDiscount = data;
      this.openPreOrderSummaryModal = false;
      this.openDiscountModal = true;
    },
    editProductsPreOrder() {
      this.openPreOrderSummaryModal = false;
      this.openProductsModal = true;
      this.updatePreOrder = true;
    },
    updatePreOrderProducts() {
      this.openQuantityModal = false;
      this.openPreOrderSummaryModal = true;
      this.updatePreOrder = false;
    },
    setNewDiscountService(value, index) {
      this.openDiscountModal = false;
      this.openPreOrderSummaryModal = true;

      this.services[index].discount_price = value
    },
    sendToNotesAndFiles(value) {
      this.openPaymentModal = false;
      this.openNotesAndFilesPopUp = true;
      this.dataOfProductsToPreOrder = value;
    },
    backToPayment() {
      this.openNotesAndFilesPopUp = false;
      this.openPaymentModal = true;
      this.isCreateContext = true;
    },
    editCustomerKnow() {
      this.isUpdate       = true;
      this.openOrderSummaryModal      = false;
      this.openCustomerKnowledgeModal = true;
    },
    backToOrderSummaryFromNotes(files, note, changeNotesFiles = true) {
      this.isUpdate = false;
      this.openNotesAndFilesPopUp = false;
      this.openOrderSummaryModal  = true;

      if (changeNotesFiles) {
        this.dataOfTurnIntoOrder.files = files;
        this.dataOfTurnIntoOrder.note = (note && note.trim() !== '') ? note : null;
      }
    },
    editNotesAndFiles() {
      this.isUpdate = true;
      this.openOrderSummaryModal = false;
      this.openNotesAndFilesPopUp = true;
    },
    backToNotesAndFiles() {
      this.openPreOrderSummaryModal = false;
      this.openNotesAndFilesPopUp = true;
    },
    sendToProductFlow(value) {
      this.openCustomerDocumentModal = false;
      this.openProductsModal = true;
      this.dataOfProductsToPreOrder = value;
    },
    sendToPayment(value) {
      this.openDeliveryModal = false;
      this.dataOfProductsToPreOrder = value;

      if (this.services && this.services.length > 0){
        this.customerKnowledge = null;
        this.openCustomerKnowledgeModal = true;
        return;
      }

      this.openPaymentModal = true;
    },
    backToDelivery() {
      this.openPaymentModal = false;

      if (this.services && this.services.length > 0){
        this.customerKnowledge = null;
        this.openCustomerKnowledgeModal = true;
        return;
      }

      this.openDeliveryModal = true;
    },
    openBuyOrderModal() {
      this.buyOrderModal = true
    },
    backToCustomerDocument() {
      this.openProductsModal = false;
      this.openCustomerDocumentModal = true;
    },
    editDeliveryOptions(value) {
      this.openOrderSummaryModal = false;
      this.isCreateContext = false;
      this.dataToUpdate = value;
      this.openDeliveryModal = true;
    },
    closeModalDelivery() {
      this.openDeliveryModal = false;
      this.isCreateContext = true;
      this.cleanEvents();
    },
    closeModalPreOrders() {
      this.openPreOrderSummaryModal = false
      this.isCreateContext = true;
      this.cleanEvents();
    },
    closeModalCustomerDocument() {
      this.openCustomerDocumentModal = false;
      this.backIsVisible = false;
      this.isCreateContext = true;
      this.cleanEvents();
    },
    closeModalPayment() {
      this.openPaymentModal = false;
      this.isCreateContext = true;
      this.cleanEvents();
    },
    backToOrderSummary(value) {
      if (value === 'payment') {
        this.openPaymentModal = false;
      } else if (value === 'product') { 
        this.openProductsModal = false;
        this.backIsVisible = false;
      } else if (value === 'quantity') {
        this.openQuantityModal = false;
        this.backIsVisible = false;
      } else {
        this.openDeliveryModal = false;
      }
      this.isCreateContext = true;
      this.openOrderSummaryModal = true;
    },
    updateOrderDelivery(value) {
      this.dataOfTurnIntoOrder = value;
      this.openDeliveryModal = false;
      this.openOrderSummaryModal = true;
      this.isCreateContext = true
    },
    updateOrderPayment(value) {
      this.dataOfTurnIntoOrder = value;
      this.openPaymentModal = false;
      this.openOrderSummaryModal = true;
      this.isCreateContext = true
    },
    searchMessages() {
      if (!this.searchTrim) { this.cleanSeach(false) }
      this.$emit('searchMessages', this.indexSearch, this.searchTrim);
    },
    editPaymentOptions(value) {
      this.openOrderSummaryModal = false;
      this.dataToUpdate = value;
      this.isCreateContext = false;
      this.openPaymentModal = true;
    },
    editProductOptions(value) {
      this.dataToUpdate = value;
      this.isCreateContext = false;
      this.openOrderSummaryModal = false;
      this.openProductsModal = true;
      this.backIsVisible = true;
    },
    cleanSeach(close = true){
      this.maxValues    = 0;
      this.indexSearch  = 0;
      this.searchQuery  = '';

      if (close) {
        this.openSearch = false;
      }
    },
    closeQuantity() {
      this.isCreateContext = true;
      this.openQuantityModal = false;
      this.backIsVisible = false;
      this.cleanEvents();
    },
    linkUser() {
      this.openOrderSummaryModal = false;
      this.openLinkUserPopUp = true;
    },
    backToOrerSummarry() {
      this.openLinkUserPopUp = false;
      this.openOrderSummaryModal = true;
    },
    backUpdateKnow(updateKnow) {
      this.isUpdate = false;
      this.openCustomerKnowledgeModal = false;
      if (updateKnow) {
        this.dataOfTurnIntoOrder.customer_knowledge_content = JSON.stringify(this.currentKnow);
      }
      this.openOrderSummaryModal = true;
    },
    setCurrentKnowledge(know){
      this.customerKnowledge = know;
      this.currentKnow = know
    },
    changeUser(user) {
      this.openLinkUserPopUp = false;
      this.openOrderSummaryModal = true;
      this.selectedUser = user;
    },
    closeOrderPopUps() {
      this.openPreOrdersModal = false;
      this.openOrderSummaryModal = false;
      this.openCustomerDocumentModal = false;
      this.openProductsModal = false;
      this.openOrdersModal = false;
      this.openQuantityModal = false;
      this.openDiscountModal = false;
      this.openPaymentModal = false;
      this.openDeliveryModal = false;
      this.openPreOrderSummaryModal = false;
      this.isActiveSentPreOrderSummary = false;
      this.modalToTransformIsActive = false;
      this.openLinkUserPopUp = false;
      this.openNotesAndFilesPopUp = false;
      this.popupDateFilter = false;
    },
    addCustomerDocument() {
      this.openCustomerDocumentModal = true;
      this.openOrderSummaryModal = false;
      this.orderContext = 'finish'
    },
    backToFinishOrder() {
      this.orderContext = ''
      this.openCustomerDocumentModal = false;
      this.openOrderSummaryModal = true;
    }
  },
  async mounted() {
    this.hasErpFeature = await hasFeature('erps');
    this.hasOrderFeature = await hasFeature('orders');
    this.hasServicesFeature = await hasFeature('services');
    this.selectedUser = this.currentUser;
  },
  created() {
    this.$events.on('closeAllPopUps',  (notify = false) => {
      if (this.isAnyModalOpen) {
        if (notify) {
          this.$vs.dialog({
            color: 'warning',
            title: `Atenção!`,
            text: 'O atendimento está sendo transferido ou encerrado, o orçamento em andamento será finalizado.',
            acceptText: 'Entendi',
          })
        }
        this.closeOrderPopUps();
      }
    });
    this.checkScreenWidth();
    window.addEventListener('resize', this.checkScreenWidth);
  },
  beforeDestroy() {
    this.$events.off('closeAllPopUps', this.closeOrderPopUps);
  }
}

</script>

<style lang="scss">
.vs-dropdown--item {
  border-radius: 0 !important;
  margin: 0 !important;
  width: 100% !important;
}

.align-items-center{
  align-items: center !important;
}

.vs-dropdown--item.divider {
  margin-top: 0 !important;
}

.vs-dropdown--item {
    .vs-dropdown--item-link {
      padding-top: 0.75rem !important;
      padding-bottom: 0.75rem !important;
      display: flex !important;
      flex-direction: row !important;
      justify-content: center !important;
      align-items: center !important;
  }
}

.con-vs-dropdown--menu {
  width: 240px !important;
}

.width-popup {
  .vs-popup {
    width: 445px !important;
  }
}

#search-input-navbar {
  .vs-input-number{
    background: none !important;
    flex-direction: column-reverse;
  }

  .vs-input-number-primary button{
    -webkit-transform: none;
    transform: none;
  }

    .vs-input-number--input {
      display: none !important;
    }
}
.actionsSelec{
  color: white;
  background-color: #0491ff;
  border-radius: 5px;
  height: 45px;
  width: 90px;
  font-size: 15.5px;
}

.requestsAttendance{
  color: white;
  background-color: #0491ff;
  border-radius: 5px;
  height: 45px;
  width: 90px;
  font-size: 15.5px;
  margin-right: 8px;
}

.input-search-ios {
  width: 8.6rem;
}

.input-search-android {
  width: 8rem;
}

</style>
